import { MouseEvent, useEffect, useRef, useState } from 'react';

import { IPartBom } from 'partBoms/types';

import { IframeContainer, Overlay, StyledIframe } from './styles';

enum MessageType {
  CLOSE = 'Close',
  RESIZE = 'Resize',
  ADD_ITEMS = 'AddItems',
}

interface IProps {
  src: string;
  onClose: () => void;
  onAddItems?: (partBom: IPartBom) => void;
}

export const IframeOverlay = ({ src, onClose, onAddItems }: IProps) => {
  const [iframeWidth, setIframeWidth] = useState(440);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === MessageType.CLOSE) {
        onClose();
      } else if (event.data?.type === MessageType.RESIZE) {
        const newWidth = event.data.payload?.width;
        if (newWidth) {
          setIframeWidth(newWidth);
        }
      } else if (event.data?.type === MessageType.ADD_ITEMS) {
        if (onAddItems && event.data.payload?.partBom) {
          onAddItems(event.data.payload.partBom);
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [onClose, onAddItems]);

  const handleOverlayClick = (e: MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <Overlay onClick={handleOverlayClick}>
      <IframeContainer width={iframeWidth}>
        <StyledIframe ref={iframeRef} src={src} title="BOM Configurator" />
      </IframeContainer>
    </Overlay>
  );
};
